import { ReactComponent as LogoWhite } from '../img/logo/logo_white.svg';
import { ReactComponent as LogoSmallWhite } from '../img/logo/logo_small_white.svg';
import { ReactComponent as LogoBlack } from '../img/logo/logo_black.svg';
import { ReactComponent as LogoSmallBlack } from '../img/logo/logo_small_black.svg';
import { useNavigate } from 'react-router-dom';

const Logo = ({ color, size = '', width, height, link }) => {
  const navigate = useNavigate();

  const maybeNavigate = () => {
    if (link) navigate(link);
  }

  const className = 'logo' + (link ? ' pointer' : '');

  switch (size+color) {
    case 'white':
      return <LogoWhite className={className} width={width} height={height} onClick={maybeNavigate} />;
    case 'smallwhite':
      return <LogoSmallWhite className={className} width={width} height={height} onClick={maybeNavigate} />;
    case 'black':
      return <LogoBlack className={className} width={width} height={height} onClick={maybeNavigate} />;
    case 'smallblack':
      return <LogoSmallBlack className={className} width={width} height={height} onClick={maybeNavigate} />;
    default:
      return <></>;
  }
}

export default Logo;